'use client';

import type { ReactNode } from 'react';

import { useGoogleMapsConsent } from './useGoogleMapsConsent';

type GoogleMapsConsentGateProps = {
    children: ReactNode;
    fallback?: ReactNode;
};

export const GoogleMapsConsentGate = ({ children, fallback = null }: GoogleMapsConsentGateProps) => {
    const canLoadGoogleMaps = useGoogleMapsConsent();

    if (!canLoadGoogleMaps) {
        return fallback;
    }

    return children;
};
